export type ColumnType = 'text' | 'number' | 'date' | 'select';

export interface ColumnMeta {
  /** Dot-path into row objects, e.g. 'customer.name'. */
  key: string;
  type: ColumnType;
  /** Known values, required for type 'select' (filter dropdown + sort order). */
  selectValues?: string[];
}

export type NumberFilterOp = 'eq' | 'ne' | 'gt' | 'lt' | 'ge' | 'le' | 'between';

export type FilterValue =
  | { type: 'text'; q: string }
  | { type: 'number'; op: NumberFilterOp; v1?: number; v2?: number }
  | { type: 'date'; from?: string; to?: string } // yyyy-mm-dd
  | { type: 'select'; value: string }; // '' = no filter

/** List queries fetch the whole table up to this cap; the truncation banner
 *  appears when the server total exceeds it. */
export const TABLE_FETCH_CAP = 2000;
